import React from 'react';
import { MdBrokenImage as IconEmpty, MdError as IconError } from 'react-icons/md';
import { useTranslation } from 'modules/i18n';

import PlaceholderSegment from './PlaceholderSegment';
import EmptyState from './EmptyState';
// import AuthorizationScreen from 'modules/auth/components/AuthorizationScreen';

interface DataResponseContainerProps {
  children: any;
  loading: boolean;
  loadingComponent?: React.ReactNode;
  data?: any;
  error?: string | any | null | undefined;
  notfound?: boolean;
  ifEmpty?: React.ComponentProps<typeof EmptyState>;
}

function DataResponseContainer(props: DataResponseContainerProps) {
  const { t } = useTranslation('common');
  const { children, data, loading, notfound, error, ifEmpty, loadingComponent } = props;

  if (loading) {
    return (
      loadingComponent || (
        <div className="flex h-52 items-center justify-center">
          <span className="loader-lg"></span>
        </div>
      )
    );
  }

  // const errorCode = error?.graphQLErrors[0]?.code || error?.graphQLErrors[0]?.message || error?.networkError?.result?.code;

  // if (errorCode === 'user:not.authorized' || errorCode === 'Not Authorised!') {
  //   return <AuthorizationScreen type="member" className="mx-auto" />;
  // }

  if (error) {
    console.error('An error occured when trying to fetch data:', error?.toString());
    return (
      <EmptyState
        className="my-5 whitespace-pre-line text-left"
        iconClassName="fill-red-600"
        icon={IconError}
        title={error?.message || error?.toString() || 'Oups, an error occured'}
        subtitle=""
      />
    );
  }

  if (notfound) {
    return (
      <PlaceholderSegment
        title={t('common:page404.excerpt', {
          defaultValue: 'Ooops!! Page not found !',
        })}
        icon={IconEmpty}
      />
    );
  }

  if (ifEmpty && data?.length === 0 && !loading) {
    return <EmptyState {...ifEmpty} />;
  }

  return children;
}

export default DataResponseContainer;
